
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as index8qxZsIuWIRWjVpQKH_ylIXjl_4raPSE6gxzFjv3MM9kMeta } from "/app/pages/[tenant]/index.vue?macro=true";
import { default as forget_45passwordb_9cvKV7RLpfuojGUieffZXS1xNS1q4kTjmk12b9LWAMeta } from "/app/pages/forget-password.vue?macro=true";
import { default as profilewx3Hyl_45ZqSu4vgmq0lcTEUAe1F_45xFb_45dGdTro6fdVNcMeta } from "/app/pages/[tenant]/profile.vue?macro=true";
import { default as indexaoGhgXA5aZyMMg_45_45QttGj_45b9ynmogJpCxXoHQgl9vdUMeta } from "/app/pages/[tenant]/city/index.vue?macro=true";
import { default as _91id_93mrQidJxXXdvCYmgWBiV24P4wbt3KhPCgSh0b9aRNwU8Meta } from "/app/pages/[tenant]/users/[id].vue?macro=true";
import { default as _91id_93tzdSWWPMun2ov_45Jrt7cWcUPZmHbrGJBW0ZKg7uR0faQMeta } from "/app/pages/[tenant]/cities/[id].vue?macro=true";
import { default as _91id_93rPKlFeSJNZi7FQyxrG_45Y_45D0yUTCVfmDmmrinhlEbmxIMeta } from "/app/pages/[tenant]/events/[id].vue?macro=true";
import { default as indexn_7thXtizfvdg2m7waZvm5PXJxD7xYmogfc31BtgDCQMeta } from "/app/pages/[tenant]/users/index.vue?macro=true";
import { default as indexxjJKobZX8OX9mH_45uNN4b6uFhbZ4OFGqa1HwVD9Mr0SEMeta } from "/app/pages/[tenant]/agenda/index.vue?macro=true";
import { default as choice_45spaceXeWc7u6_jDJ6ywy6_45yGBTh_45GX_vSLY_C9oxaqamVlsIMeta } from "/app/pages/[tenant]/choice-space.vue?macro=true";
import { default as indexVVKpnZASz9lKAei6TgY2HdFlQfV_45XdSF8w_45Fox_45zTtkMeta } from "/app/pages/[tenant]/cities/index.vue?macro=true";
import { default as profileVob9ouyemyhcQZqTUlna1ymhJkdurPh6SP71O_45r54WkMeta } from "/app/pages/[tenant]/city/profile.vue?macro=true";
import { default as index4eoO_hYpsDtAuMfShyP_XrO00R2ogw6BTLm1L6WenG8Meta } from "/app/pages/[tenant]/events/index.vue?macro=true";
import { default as _91id_93hW_45eOOseBItMz_45rnzA_oQyF598T6kTDaQ5yJh_45GijuEMeta } from "/app/pages/[tenant]/markets/[id].vue?macro=true";
import { default as _91id_93o0IVa2zossOOmW5YmCN1Viv0mRZ1kKK9vqZ1HrSPIUoMeta } from "/app/pages/[tenant]/balances/[id].vue?macro=true";
import { default as indexn_45IZziyu_45MT7WiNjdvimEdFSuttl7r69TaxLvFcVqysMeta } from "/app/pages/[tenant]/markets/index.vue?macro=true";
import { default as _91id_93MZytXftPSNU4_45GIp0U9MFaCW0KnZw0cuX0v8husoaK4Meta } from "/app/pages/[tenant]/payments/[id].vue?macro=true";
import { default as indexYA9GTDvYw5fhEyumgEmMyIA0geLMTdCUFaQdAkqs0f0Meta } from "/app/pages/[tenant]/placers/index.vue?macro=true";
import { default as mainC5PkIaIcbnBkSRBp824OICqhJaazc3G0dNEwC1GDKb8Meta } from "/app/pages/[tenant]/settings/main.vue?macro=true";
import { default as indexTU_LwAbeDlGsFu2ZeFpnDeDHk4swVk00qLwhpuI8VlgMeta } from "/app/pages/[tenant]/absences/index.vue?macro=true";
import { default as indexBqUdsQ6hKwKMb8OA7jHNOa6vlMupeOPIjuhS_458ivgK4Meta } from "/app/pages/[tenant]/balances/index.vue?macro=true";
import { default as _91id_93d87PK63ctip2LjGBSDmA952m8OjuVZBpDTsDaEbVx9gMeta } from "/app/pages/[tenant]/companies/[id].vue?macro=true";
import { default as indexcQuQO5FimU1Vg8uwi8bBZ3qu_45VHhjktV1zFQ14pby0QMeta } from "/app/pages/[tenant]/deposits/index.vue?macro=true";
import { default as index2PbRd7rAU0vqC8G2BN3FMR6plvsNsv5ToWa3QNtJcIgMeta } from "/app/pages/[tenant]/invoices/index.vue?macro=true";
import { default as _91id_935J8sEquGn8eAZSNMkB4JrhFUHCvKGAPBjEsFoHPt2W4Meta } from "/app/pages/[tenant]/materials/[id].vue?macro=true";
import { default as _91id_93f_45ckJn83O6TR20TAl7nC2_ic1g5UPrheZ_9_45x6KPLwYMeta } from "/app/pages/[tenant]/merchants/[id].vue?macro=true";
import { default as indexUc1IXztN352XSdnrzMKEQjlVNfDlvf9yn2P5G2R5AtkMeta } from "/app/pages/[tenant]/payments/index.vue?macro=true";
import { default as indexqaaV4O2A7edb1wFKMEKcpKEnTXYwBp_45XFBbcHauNri0Meta } from "/app/pages/[tenant]/products/index.vue?macro=true";
import { default as indexenTZ0jzXvkhSEjdIFkNbTlIvK_45yWIr4WmHZzsMEoLGIMeta } from "/app/pages/[tenant]/renewals/index.vue?macro=true";
import { default as indexgbl8BJjEqMkZ7BeqxmfDEcalZ70D1zdb29e_45EhIKHEEMeta } from "/app/pages/[tenant]/settings/index.vue?macro=true";
import { default as indexxrct27Wp17vbP_dfoIkVN0MD5bxORWWwk0J0M2wi58MMeta } from "/app/pages/[tenant]/companies/index.vue?macro=true";
import { default as edit91fD9J3cv0_Ke3mvVf2kcHT0ZhrD9SnvAjsl6Kfr04kMeta } from "/app/pages/[tenant]/equipments/[id]/edit.vue?macro=true";
import { default as _91id_93E1uzpGYPpiZG7qIKFmZjOjZobFKhoV_bz11xuQ7_EMUMeta } from "/app/pages/[tenant]/equipments/[id].vue?macro=true";
import { default as indexfVo2fpI6zyPQ2cRDM0N_3S0a_45POvZogOLO3C6a1AUmkMeta } from "/app/pages/[tenant]/locations/index.vue?macro=true";
import { default as indexlV_45iIOuTJ_45YrFOsTtrY4XdVGIMp7M1fcY4GYKyFic_0Meta } from "/app/pages/[tenant]/materials/index.vue?macro=true";
import { default as indexv2ewTb2AzAGStWvGrps_r9Kd4JeJFOMZNmn7F_45DZ1_45cMeta } from "/app/pages/[tenant]/merchants/index.vue?macro=true";
import { default as createM6tTrD7UPDtmTRXFgvP3YDsMM_BxBofLxiH5zPasZ8MMeta } from "/app/pages/[tenant]/payments/create.vue?macro=true";
import { default as systemBq4dEaWoZLVKCxcGqaC4HqYDsZYAT3YWAQBJMu45_ewMeta } from "/app/pages/[tenant]/settings/system.vue?macro=true";
import { default as _91id_93ZHzYfg8Jnj8Wt1P_nejuaH26F1xL42PRdkJxAVmmc3cMeta } from "/app/pages/[tenant]/city/events/[id].vue?macro=true";
import { default as indexxyMcIT0ZZORbCet2XknXiuAUpbNXvlSPWyga6exMCi8Meta } from "/app/pages/[tenant]/equipments/index.vue?macro=true";
import { default as billingR3wdTx52CK2NeTo8kmgUG_45fH1xQp52i4kjanYt11TYoMeta } from "/app/pages/[tenant]/settings/billing.vue?macro=true";
import { default as index8sIrBmGe4Nafm_45UUgSftg7uakNOsG0rS0vTLdXOUZd4Meta } from "/app/pages/[tenant]/city/events/index.vue?macro=true";
import { default as _91id_93NejJIsCicDzbK3SZbCNl_PMh96qhy7CMOhhZWsfhVM4Meta } from "/app/pages/[tenant]/city/markets/[id].vue?macro=true";
import { default as createvlMRH3tTTfYPI4MNE5brUgYYzJVptYBxvhqAdMDP5k8Meta } from "/app/pages/[tenant]/equipments/create.vue?macro=true";
import { default as _91id_93kkWa1DBRJoxcJCoAQJ6AmNfFFfrstfSodIPiAV3IblAMeta } from "/app/pages/[tenant]/placers/show/[id].vue?macro=true";
import { default as securityDtTc3MHMKt6cH0AvQpXo_45yQr0VWVz_D_451E_3sjgKN9kMeta } from "/app/pages/[tenant]/settings/security.vue?macro=true";
import { default as _91id_934I3YGcC525OkiRA_YYM9o17H_cjRszYEm4vUZKVV43YMeta } from "/app/pages/[tenant]/city/invoices/[id].vue?macro=true";
import { default as indexKSCGxLKuR4BXN2s_7OazhwYCY_45CwXXpkTWCb_45Y_45wMU8Meta } from "/app/pages/[tenant]/city/markets/index.vue?macro=true";
import { default as _91id_930gN5_45PKMBJ9QuKYQf2izE8gZRXvPe5v1FDFcWmEYSTEMeta } from "/app/pages/[tenant]/invoices/show/[id].vue?macro=true";
import { default as indexdWZyUHuOtUY3b_4_45XR0Uu5lVtcFanYjvb_45KnxQN_45kBoMeta } from "/app/pages/[tenant]/cashregisters/index.vue?macro=true";
import { default as indexbtWTdoGjx3FLBwGW0LoAN_45gu0A8uWEOfQZ7VS9oElagMeta } from "/app/pages/[tenant]/city/invoices/index.vue?macro=true";
import { default as _91id_93gEECz62Z6SycPr1lzD_AbGAfVkmsr0nQU2Nxc835XDgMeta } from "/app/pages/[tenant]/city/merchants/[id].vue?macro=true";
import { default as indexIRzgI58LVS2d2Uad_S6utiUbhIWM_45XXQ5pEmyYUbI6kMeta } from "/app/pages/[tenant]/city/settings/index.vue?macro=true";
import { default as indexm263w0F784KnYbIPsor1yOF0ns_ehQ3LvubhA8GwcnsMeta } from "/app/pages/[tenant]/notifications/index.vue?macro=true";
import { default as appearanceFHoMXDAa3TfsTNtyl1awLSzcHhiCNv74dOuzGM3xlPsMeta } from "/app/pages/[tenant]/settings/appearance.vue?macro=true";
import { default as automatingG1qJejSXX1KzODBKHLKF17H3du_G10leVYe9Dm4YA0kMeta } from "/app/pages/[tenant]/settings/automating.vue?macro=true";
import { default as navigation0ZB4dQPNZ6JleOhWEys3k6da47BMR0EYu7POPWN3zOAMeta } from "/app/pages/[tenant]/settings/navigation.vue?macro=true";
import { default as indexZmSFDCZv5u7y2V4rZ_PC2N6DTWF3eqlNdYwPiCMLgJYMeta } from "/app/pages/[tenant]/subscriptions/index.vue?macro=true";
import { default as index6tcEEsL3vEDyLK5w_45nzmvMwSlmD1EXOotbwxe6KFG7kMeta } from "/app/pages/reset-password/[token]/index.vue?macro=true";
import { default as indexLoGl09YIXQBhZ_45iRDhNlm8FJZs8sYf0RpgxBocG0S7oMeta } from "/app/pages/[tenant]/city/documents/index.vue?macro=true";
import { default as indexICsKjv68RwkgljQFkPmfjfRoDZUEPBilGcKccd_6u5cMeta } from "/app/pages/[tenant]/city/merchants/index.vue?macro=true";
import { default as indexWDkLAIb2VQNIEC_MuohLDQW93BIo0icin5J9XPU_45pSMMeta } from "/app/pages/[tenant]/deduplications/index.vue?macro=true";
import { default as indexAQ1gyDgHXYtLnSAhP3W1krHyipVxXXJMMSumHzgk7p4Meta } from "/app/pages/[tenant]/email-failures/index.vue?macro=true";
import { default as create_45editWkKTDn4rNqVjxDyP_459QqP1hPTBI6JyQvReHvj6wW7MgMeta } from "/app/pages/[tenant]/invoices/create-edit.vue?macro=true";
import { default as media_45typesRKj5hWzF7EnpORWFfVcHYdQotVkR82wvaMWL5akVAYwMeta } from "/app/pages/[tenant]/settings/media-types.vue?macro=true";
import { default as index0JODX171bp_45beXj0_45lCZozxZMfCkgLqtiERZ2nDDB_45EMeta } from "/app/pages/[tenant]/city/statistics/index.vue?macro=true";
import { default as indexRgEBaLSF_45k_45vOrrdPUFGhCDgTkqkP9rUYWYXZa5y7bIMeta } from "/app/pages/[tenant]/company-balance/index.vue?macro=true";
import { default as to_45qualifyu7UZmD_VbLVxaGN_l5QzZ_dYwLjlMg27KcZPCT6YsbIMeta } from "/app/pages/[tenant]/equipments/to-qualify.vue?macro=true";
import { default as indexCEqBLl6PGqf897HXmf1GlpB23_45d4IwwOX6b6BZ1h70sMeta } from "/app/pages/[tenant]/placer-planning/index.vue?macro=true";
import { default as indexhK3G5U4z2wJ1KBA_mBDqVyAnd_45HQyi6dgXA6BJaFC_45AMeta } from "/app/pages/[tenant]/report-template/index.vue?macro=true";
import { default as activity_45log3MCDHV4lqDBRL10KDwrYwC6OWPdnWUw5RK_45wtO_sFnoMeta } from "/app/pages/[tenant]/settings/activity-log.vue?macro=true";
import { default as email_45healthGsv_5k1E50F490eZOpQ5OFHoLT1rvVPAEqiYbPl8SNIMeta } from "/app/pages/[tenant]/settings/email-health.vue?macro=true";
import { default as _91email_93Yb1LGNTunHcs9h9neB9jYEBvHdJCYSYAVNfLyq0nZbcMeta } from "/app/pages/reset-password/[token]/[email].vue?macro=true";
import { default as indexDOgdlPTfMO6EUMvU5rKU7V8dCb8AfYmrHiSmy7obqm0Meta } from "/app/pages/[tenant]/audit-passengers/index.vue?macro=true";
import { default as indexUG64zwFhit6Jjp1NoXtiVildazppo6fn1hD8HMgGjTIMeta } from "/app/pages/[tenant]/billing-entities/index.vue?macro=true";
import { default as securityGNgLiCipexhmeT0FR2ewVMIWcrAJ1AZQO4NSr_2zkR8Meta } from "/app/pages/[tenant]/city/settings/security.vue?macro=true";
import { default as manage_45pricesgH2OmDK0EbpRtYjttl9f0wCPKJLAK5UT0Dupr2QhdjYMeta } from "/app/pages/[tenant]/products/manage-prices.vue?macro=true";
import { default as _91id_93TDlOg2_dsZw_bPXz7UzFT9x7BwgZaJPrSb7N2V_V6nMMeta } from "/app/pages/[tenant]/cashregisters/show/[id].vue?macro=true";
import { default as _91id_93SgiBOiBIoqjYzU50UDLiQbEqTvJwcPxUlV62xSbUBDIMeta } from "/app/pages/[tenant]/city/invoices/show/[id].vue?macro=true";
import { default as indexVliVKNmSL0YeeKOnAhiGetWlgYIHPjj0HbyH3chvn1cMeta } from "/app/pages/[tenant]/document-required/index.vue?macro=true";
import { default as index57JpBbwpmHU_uPJegKEqvUaZUGT7BgQh1OkORXYP9jIMeta } from "/app/pages/[tenant]/exportaccountancy/index.vue?macro=true";
import { default as offer_45invoices5HEY7JiXivm2cLiWq29f1YKX2HwHGDpb9rh2PjKPeswMeta } from "/app/pages/[tenant]/invoices/offer-invoices.vue?macro=true";
import { default as indexwMU0lfOIvHEtElmFcLthDEm1tquiNdtahKK7U0wiwGQMeta } from "/app/pages/[tenant]/payment-anomalies/index.vue?macro=true";
import { default as payment_45rateskXgNftDZH_Q1AklDWxymMXXKnhvLE2lWqAiXBikZ_XwMeta } from "/app/pages/[tenant]/reporting/payment-rates.vue?macro=true";
import { default as _91id_93tzPiRv3Zxq6pFMU_GVk4_MD_eqWBJGt5_45iKdQ6cysHkMeta } from "/app/pages/[tenant]/subscriptions/show/[id].vue?macro=true";
import { default as indexWGFqyqen_45q_45zN9xUgDD0SP8vqDXjVCy7hTMBJUFXFucMeta } from "/app/pages/[tenant]/city/market-report/index.vue?macro=true";
import { default as appearanceF_454keGASRkB34lHceM6lkB_gT9qR_Is42Zq58yagtQ4Meta } from "/app/pages/[tenant]/city/settings/appearance.vue?macro=true";
import { default as credit_45invoicesucZoLmr05z5TPUQAzS_45T06gWXukhxMwVRKgNyD0EjZQMeta } from "/app/pages/[tenant]/invoices/credit-invoices.vue?macro=true";
import { default as indexJmQ_jBRbY9oMq9FLSim6MdauiDuR12EZXk5IjE4g9NUMeta } from "/app/pages/[tenant]/markets/draw-shape/index.vue?macro=true";
import { default as equipment_45typesR4KwB9CmKMLyvbTwpDvVIvD6S8aXzK9hK1iqQfHZuLkMeta } from "/app/pages/[tenant]/settings/equipment-types.vue?macro=true";
import { default as placer_45presence2YgTF14F9OJ2Ey_45_IQNanSFmN35u2PkpI1P8lZQ5CFIMeta } from "/app/pages/[tenant]/settings/placer-presence.vue?macro=true";
import { default as city_45assignmentsNaCdOz_45MNJTYlHnEXHEGy8xuZ9vO89quODBO1pmuqWIMeta } from "/app/pages/[tenant]/settings/city-assignments.vue?macro=true";
import { default as company_45balancesZ5vm0hEbBsBzBec5t6Hn6CIqlVw7OKaarc2Ukry1s9gMeta } from "/app/pages/[tenant]/settings/company-balances.vue?macro=true";
import { default as emergency_45bypassIz_ivyRVUMDO9FeIz90GUdZ3dpdlLMLFrj76TAC9mccMeta } from "/app/pages/[tenant]/settings/emergency-bypass.vue?macro=true";
import { default as create_45editF96DNhSwd3pSZ3vgj4nfKp_45g8Sd_z7_45TI_45iIaqMLV6IMeta } from "/app/pages/[tenant]/subscriptions/create-edit.vue?macro=true";
import { default as noactive_45invoicesuWY0O8EIKm6EQJwV4hbBySRgkTatfO1gV3XOcyfSGv8Meta } from "/app/pages/[tenant]/invoices/noactive-invoices.vue?macro=true";
import { default as indexy9U_45bFfqhGVvBl75EFlt53iqMP3dYvzn8xmfeQCHnAcMeta } from "/app/pages/[tenant]/placer-entry-quality/index.vue?macro=true";
import { default as index3p32ZhiM727Dfi_45fU_45pMFAA_45V6LNeHFKJbDWcUVnxqQMeta } from "/app/pages/[tenant]/report-template/list/index.vue?macro=true";
import { default as backofficeYSVcXshvWtlTgdSlWKZMICkOlSlveskz4_45I_45aW57pu8Meta } from "/app/pages/[tenant]/audit-passengers/backoffice.vue?macro=true";
import { default as agenda_45entry_45typeskbE4hJ4zFvEtxVasWKcmEpDzTl_453WUDOaj3Lbc6XcA4Meta } from "/app/pages/[tenant]/settings/agenda-entry-types.vue?macro=true";
import { default as indexUIInWBDMo7tKGchJUV0An9VpOpwOA5N31ii65AQ5YP0Meta } from "/app/pages/[tenant]/settings/integrations/index.vue?macro=true";
import { default as deduplicate_45searchhoWAR30U1wzFHvql0X7IhucDAx3C1W0unYR4oNTAqpQMeta } from "/app/pages/[tenant]/merchants/deduplicate-search.vue?macro=true";
import { default as indexTgN3FuMKu0FWqebnVL8mDZahgkMEKyYB_45RsQmQYUdOwMeta } from "/app/pages/[tenant]/report-template/create/index.vue?macro=true";
import { default as city_45assignmentsEO2YzwnN0TUviIM6sb_45q7AHQXN0znb6E9rSKtHLzB0sMeta } from "/app/pages/[tenant]/city/settings/city-assignments.vue?macro=true";
import { default as index4wqha9bqxAki1JsinWXg8d_FEYsTpYqrcpkOds4g9wkMeta } from "/app/pages/[tenant]/deduplications/companies/index.vue?macro=true";
import { default as organilogynBKA6dDajE7VIj944ojBekCGFb5SFjaLmeXPFTxcaAMeta } from "/app/pages/[tenant]/settings/integrations/organilog.vue?macro=true";
import { default as history2fDIjbmd9JaYkFCm5ZNV6mk0NGdmzWLGNkcLS2hvwYYMeta } from "/app/pages/[tenant]/deduplications/companies/history.vue?macro=true";
import { default as _91market_report_id_937mNwvxS_9DomBPN0hC6iK94rBOH2W1jJ1HmCX5ITPlwMeta } from "/app/pages/[tenant]/market-report/[market_report_id].vue?macro=true";
import { default as _91market_id_931Aarbrv_45zZjldeH5aVdhykYYxMMhAHHVOZHTVQolHosMeta } from "/app/pages/[tenant]/market-report/create/[market_id].vue?macro=true";
import { default as notification_45recipientsOF_E7l7CMvQ7m7yvBoLlJq0X0Wlh_45nNAd4QCpsPPEH4Meta } from "/app/pages/[tenant]/settings/notification-recipients.vue?macro=true";
import { default as _91template_id_93GFVVb_f76p22hoQAO5NkYRw4iAA_45GLZOx6V5C1fM_REMeta } from "/app/pages/[tenant]/report-template/edit/[template_id].vue?macro=true";
import { default as report_45_91sessionId_93ndy72G2MFC65AIfeTygkSRYTV68GyvIziCZ1H8Jl_FgMeta } from "/app/pages/[tenant]/audit-passengers/report-[sessionId].vue?macro=true";
import { default as deduplications_history_uwuOfsH3161qf_WOnOlfF_45r_LtAa94r_45e_45jYWnDdSQMeta } from "/app/pages/[tenant]/deduplications/deduplications_history.vue?macro=true";
import { default as indexSJJNmSnKHx3ZoGSa1k1qzQH_eFV0XA1Dq_9gHSG_45augMeta } from "/app/pages/[tenant]/passenger-merchants-performance/index.vue?macro=true";
import { default as _91id_933PWOwZ4rGaIAvEfFZdbnRp0Jns8ND088Lj71QhZutyYMeta } from "/app/pages/[tenant]/subscriptions/renewal_exceptions/[id].vue?macro=true";
import { default as _91date_93e60DQZDT2KOxfgNtZbawRaHx5JMBnJ7tBBx5dXRFtPAMeta } from "/app/pages/[tenant]/market-report/daily/[market_id]/[date].vue?macro=true";
import { default as indexBjx6Qs8GfgLgaGSDvinC_45sWik7iXARSsFu_30dGgoVcMeta } from "/app/pages/[tenant]/subscriptions/renewal_exceptions/index.vue?macro=true";
import { default as createYKPkyersFQMSTjxhew7fBcnhBujmieVu73v50TNfnJEMeta } from "/app/pages/[tenant]/subscriptions/renewal_exceptions/create.vue?macro=true";
import { default as _91date_93aw5yRCa8M1zWM9V3kmdkwJXPNrz2qMoqIcorWjLW3U0Meta } from "/app/pages/[tenant]/city/market-report/daily/[market_id]/[date].vue?macro=true";
import { default as exceptionsNBTU73OmyCOJMBirbcSeO8_cLZxXIup3mrm3beSl8uIMeta } from "/app/pages/[tenant]/subscriptions/renewal_exceptions/exceptions.vue?macro=true";
import { default as create_45editdu73qv_452gv4nSpZbdjsyl_7N2dt00qTcJSS9xBZW9CwMeta } from "~/pages/[tenant]/subscriptions/create-edit.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {}), ...{"layout":"guest","middleware":["nuxt-permissions","sanctum:guest"]} },
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: {"layout":"guest","middleware":["nuxt-permissions","sanctum:guest"]},
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "tenant",
    path: "/:tenant()",
    meta: { ...(index8qxZsIuWIRWjVpQKH_ylIXjl_4raPSE6gxzFjv3MM9kMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/index.vue")
  },
  {
    name: "forget-password",
    path: "/forget-password",
    meta: {"layout":"guest","middleware":["nuxt-permissions","sanctum:guest"]},
    component: () => import("/app/pages/forget-password.vue")
  },
  {
    name: "tenant-profile",
    path: "/:tenant()/profile",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/profile.vue")
  },
  {
    name: "tenant-city",
    path: "/:tenant()/city",
    meta: { ...(indexaoGhgXA5aZyMMg_45_45QttGj_45b9ynmogJpCxXoHQgl9vdUMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/index.vue")
  },
  {
    name: "tenant-users-id",
    path: "/:tenant()/users/:id()",
    meta: { ...(_91id_93mrQidJxXXdvCYmgWBiV24P4wbt3KhPCgSh0b9aRNwU8Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/users/[id].vue")
  },
  {
    name: "tenant-cities-id",
    path: "/:tenant()/cities/:id()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/cities/[id].vue")
  },
  {
    name: "tenant-events-id",
    path: "/:tenant()/events/:id()",
    meta: { ...(_91id_93rPKlFeSJNZi7FQyxrG_45Y_45D0yUTCVfmDmmrinhlEbmxIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/events/[id].vue")
  },
  {
    name: "tenant-users",
    path: "/:tenant()/users",
    meta: { ...(indexn_7thXtizfvdg2m7waZvm5PXJxD7xYmogfc31BtgDCQMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/users/index.vue")
  },
  {
    name: "tenant-agenda",
    path: "/:tenant()/agenda",
    meta: { ...(indexxjJKobZX8OX9mH_45uNN4b6uFhbZ4OFGqa1HwVD9Mr0SEMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/agenda/index.vue")
  },
  {
    name: "tenant-choice-space",
    path: "/:tenant()/choice-space",
    meta: { ...(choice_45spaceXeWc7u6_jDJ6ywy6_45yGBTh_45GX_vSLY_C9oxaqamVlsIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/choice-space.vue")
  },
  {
    name: "tenant-cities",
    path: "/:tenant()/cities",
    meta: { ...(indexVVKpnZASz9lKAei6TgY2HdFlQfV_45XdSF8w_45Fox_45zTtkMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/cities/index.vue")
  },
  {
    name: "tenant-city-profile",
    path: "/:tenant()/city/profile",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"},
    component: () => import("/app/pages/[tenant]/city/profile.vue")
  },
  {
    name: "tenant-events",
    path: "/:tenant()/events",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/events/index.vue")
  },
  {
    name: "tenant-markets-id",
    path: "/:tenant()/markets/:id()",
    meta: { ...(_91id_93hW_45eOOseBItMz_45rnzA_oQyF598T6kTDaQ5yJh_45GijuEMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/markets/[id].vue")
  },
  {
    name: "tenant-balances-id",
    path: "/:tenant()/balances/:id()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/balances/[id].vue")
  },
  {
    name: "tenant-markets",
    path: "/:tenant()/markets",
    meta: { ...(indexn_45IZziyu_45MT7WiNjdvimEdFSuttl7r69TaxLvFcVqysMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/markets/index.vue")
  },
  {
    name: "tenant-payments-id",
    path: "/:tenant()/payments/:id()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/payments/[id].vue")
  },
  {
    name: "tenant-placers",
    path: "/:tenant()/placers",
    meta: { ...(indexYA9GTDvYw5fhEyumgEmMyIA0geLMTdCUFaQdAkqs0f0Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/placers/index.vue")
  },
  {
    name: "tenant-settings-main",
    path: "/:tenant()/settings/main",
    meta: { ...(mainC5PkIaIcbnBkSRBp824OICqhJaazc3G0dNEwC1GDKb8Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/main.vue")
  },
  {
    name: "tenant-absences",
    path: "/:tenant()/absences",
    meta: { ...(indexTU_LwAbeDlGsFu2ZeFpnDeDHk4swVk00qLwhpuI8VlgMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/absences/index.vue")
  },
  {
    name: "tenant-balances",
    path: "/:tenant()/balances",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/balances/index.vue")
  },
  {
    name: "tenant-companies-id",
    path: "/:tenant()/companies/:id()",
    meta: { ...(_91id_93d87PK63ctip2LjGBSDmA952m8OjuVZBpDTsDaEbVx9gMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/companies/[id].vue")
  },
  {
    name: "tenant-deposits",
    path: "/:tenant()/deposits",
    meta: { ...(indexcQuQO5FimU1Vg8uwi8bBZ3qu_45VHhjktV1zFQ14pby0QMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/deposits/index.vue")
  },
  {
    name: "tenant-invoices",
    path: "/:tenant()/invoices",
    meta: { ...(index2PbRd7rAU0vqC8G2BN3FMR6plvsNsv5ToWa3QNtJcIgMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/invoices/index.vue")
  },
  {
    name: "tenant-materials-id",
    path: "/:tenant()/materials/:id()",
    meta: { ...(_91id_935J8sEquGn8eAZSNMkB4JrhFUHCvKGAPBjEsFoHPt2W4Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/materials/[id].vue")
  },
  {
    name: "tenant-merchants-id",
    path: "/:tenant()/merchants/:id()",
    meta: { ...(_91id_93f_45ckJn83O6TR20TAl7nC2_ic1g5UPrheZ_9_45x6KPLwYMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/merchants/[id].vue")
  },
  {
    name: "tenant-payments",
    path: "/:tenant()/payments",
    meta: { ...(indexUc1IXztN352XSdnrzMKEQjlVNfDlvf9yn2P5G2R5AtkMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/payments/index.vue")
  },
  {
    name: "tenant-products",
    path: "/:tenant()/products",
    meta: { ...(indexqaaV4O2A7edb1wFKMEKcpKEnTXYwBp_45XFBbcHauNri0Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/products/index.vue")
  },
  {
    name: "tenant-renewals",
    path: "/:tenant()/renewals",
    meta: { ...(indexenTZ0jzXvkhSEjdIFkNbTlIvK_45yWIr4WmHZzsMEoLGIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/renewals/index.vue")
  },
  {
    name: "tenant-settings",
    path: "/:tenant()/settings",
    meta: { ...(indexgbl8BJjEqMkZ7BeqxmfDEcalZ70D1zdb29e_45EhIKHEEMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/index.vue")
  },
  {
    name: "tenant-companies",
    path: "/:tenant()/companies",
    meta: { ...(indexxrct27Wp17vbP_dfoIkVN0MD5bxORWWwk0J0M2wi58MMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/companies/index.vue")
  },
  {
    name: "tenant-equipments-id",
    path: "/:tenant()/equipments/:id()",
    meta: { ...(_91id_93E1uzpGYPpiZG7qIKFmZjOjZobFKhoV_bz11xuQ7_EMUMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/equipments/[id].vue"),
    children: [
  {
    name: "tenant-equipments-id-edit",
    path: "edit",
    meta: { ...(edit91fD9J3cv0_Ke3mvVf2kcHT0ZhrD9SnvAjsl6Kfr04kMeta || {}), ...{"layout":"guest","middleware":["nuxt-permissions","sanctum:guest"]} },
    component: () => import("/app/pages/[tenant]/equipments/[id]/edit.vue")
  }
]
  },
  {
    name: "tenant-locations",
    path: "/:tenant()/locations",
    meta: { ...(indexfVo2fpI6zyPQ2cRDM0N_3S0a_45POvZogOLO3C6a1AUmkMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/locations/index.vue")
  },
  {
    name: "tenant-materials",
    path: "/:tenant()/materials",
    meta: { ...(indexlV_45iIOuTJ_45YrFOsTtrY4XdVGIMp7M1fcY4GYKyFic_0Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/materials/index.vue")
  },
  {
    name: "tenant-merchants",
    path: "/:tenant()/merchants",
    meta: { ...(indexv2ewTb2AzAGStWvGrps_r9Kd4JeJFOMZNmn7F_45DZ1_45cMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/merchants/index.vue")
  },
  {
    name: "tenant-payments-create",
    path: "/:tenant()/payments/create",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/payments/create.vue")
  },
  {
    name: "tenant-settings-system",
    path: "/:tenant()/settings/system",
    meta: { ...(systemBq4dEaWoZLVKCxcGqaC4HqYDsZYAT3YWAQBJMu45_ewMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/system.vue")
  },
  {
    name: "tenant-city-events-id",
    path: "/:tenant()/city/events/:id()",
    meta: { ...(_91id_93ZHzYfg8Jnj8Wt1P_nejuaH26F1xL42PRdkJxAVmmc3cMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/events/[id].vue")
  },
  {
    name: "tenant-equipments",
    path: "/:tenant()/equipments",
    meta: { ...(indexxyMcIT0ZZORbCet2XknXiuAUpbNXvlSPWyga6exMCi8Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/equipments/index.vue")
  },
  {
    name: "tenant-settings-billing",
    path: "/:tenant()/settings/billing",
    meta: { ...(billingR3wdTx52CK2NeTo8kmgUG_45fH1xQp52i4kjanYt11TYoMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/billing.vue")
  },
  {
    name: "tenant-city-events",
    path: "/:tenant()/city/events",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"},
    component: () => import("/app/pages/[tenant]/city/events/index.vue")
  },
  {
    name: "tenant-city-markets-id",
    path: "/:tenant()/city/markets/:id()",
    meta: { ...(_91id_93NejJIsCicDzbK3SZbCNl_PMh96qhy7CMOhhZWsfhVM4Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/markets/[id].vue")
  },
  {
    name: "tenant-equipments-create",
    path: "/:tenant()/equipments/create",
    meta: { ...(createvlMRH3tTTfYPI4MNE5brUgYYzJVptYBxvhqAdMDP5k8Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/equipments/create.vue")
  },
  {
    name: "tenant-placers-show-id",
    path: "/:tenant()/placers/show/:id()",
    meta: { ...(_91id_93kkWa1DBRJoxcJCoAQJ6AmNfFFfrstfSodIPiAV3IblAMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/placers/show/[id].vue")
  },
  {
    name: "tenant-settings-security",
    path: "/:tenant()/settings/security",
    meta: { ...(securityDtTc3MHMKt6cH0AvQpXo_45yQr0VWVz_D_451E_3sjgKN9kMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/security.vue")
  },
  {
    name: "tenant-city-invoices-id",
    path: "/:tenant()/city/invoices/:id()",
    meta: { ...(_91id_934I3YGcC525OkiRA_YYM9o17H_cjRszYEm4vUZKVV43YMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/invoices/[id].vue")
  },
  {
    name: "tenant-city-markets",
    path: "/:tenant()/city/markets",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"},
    component: () => import("/app/pages/[tenant]/city/markets/index.vue")
  },
  {
    name: "tenant-invoices-show-id",
    path: "/:tenant()/invoices/show/:id()",
    meta: { ...(_91id_930gN5_45PKMBJ9QuKYQf2izE8gZRXvPe5v1FDFcWmEYSTEMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/invoices/show/[id].vue")
  },
  {
    name: "tenant-cashregisters",
    path: "/:tenant()/cashregisters",
    meta: { ...(indexdWZyUHuOtUY3b_4_45XR0Uu5lVtcFanYjvb_45KnxQN_45kBoMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/cashregisters/index.vue")
  },
  {
    name: "tenant-city-invoices",
    path: "/:tenant()/city/invoices",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"},
    component: () => import("/app/pages/[tenant]/city/invoices/index.vue")
  },
  {
    name: "tenant-city-merchants-id",
    path: "/:tenant()/city/merchants/:id()",
    meta: { ...(_91id_93gEECz62Z6SycPr1lzD_AbGAfVkmsr0nQU2Nxc835XDgMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/merchants/[id].vue")
  },
  {
    name: "tenant-city-settings",
    path: "/:tenant()/city/settings",
    meta: { ...(indexIRzgI58LVS2d2Uad_S6utiUbhIWM_45XXQ5pEmyYUbI6kMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/settings/index.vue")
  },
  {
    name: "tenant-notifications",
    path: "/:tenant()/notifications",
    meta: { ...(indexm263w0F784KnYbIPsor1yOF0ns_ehQ3LvubhA8GwcnsMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/notifications/index.vue")
  },
  {
    name: "tenant-settings-appearance",
    path: "/:tenant()/settings/appearance",
    meta: { ...(appearanceFHoMXDAa3TfsTNtyl1awLSzcHhiCNv74dOuzGM3xlPsMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/appearance.vue")
  },
  {
    name: "tenant-settings-automating",
    path: "/:tenant()/settings/automating",
    meta: { ...(automatingG1qJejSXX1KzODBKHLKF17H3du_G10leVYe9Dm4YA0kMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/automating.vue")
  },
  {
    name: "tenant-settings-navigation",
    path: "/:tenant()/settings/navigation",
    meta: { ...(navigation0ZB4dQPNZ6JleOhWEys3k6da47BMR0EYu7POPWN3zOAMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/navigation.vue")
  },
  {
    name: "tenant-subscriptions",
    path: "/:tenant()/subscriptions",
    meta: { ...(indexZmSFDCZv5u7y2V4rZ_PC2N6DTWF3eqlNdYwPiCMLgJYMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/index.vue")
  },
  {
    name: "reset-password-token",
    path: "/reset-password/:token()",
    meta: {"layout":"guest","middleware":["nuxt-permissions","sanctum:guest"]},
    component: () => import("/app/pages/reset-password/[token]/index.vue")
  },
  {
    name: "tenant-city-documents",
    path: "/:tenant()/city/documents",
    meta: { ...(indexLoGl09YIXQBhZ_45iRDhNlm8FJZs8sYf0RpgxBocG0S7oMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/documents/index.vue")
  },
  {
    name: "tenant-city-merchants",
    path: "/:tenant()/city/merchants",
    meta: { ...(indexICsKjv68RwkgljQFkPmfjfRoDZUEPBilGcKccd_6u5cMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/merchants/index.vue")
  },
  {
    name: "tenant-deduplications",
    path: "/:tenant()/deduplications",
    meta: { ...(indexWDkLAIb2VQNIEC_MuohLDQW93BIo0icin5J9XPU_45pSMMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/deduplications/index.vue")
  },
  {
    name: "tenant-email-failures",
    path: "/:tenant()/email-failures",
    meta: { ...(indexAQ1gyDgHXYtLnSAhP3W1krHyipVxXXJMMSumHzgk7p4Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/email-failures/index.vue")
  },
  {
    name: "tenant-invoices-create-edit",
    path: "/:tenant()/invoices/create-edit",
    meta: { ...(create_45editWkKTDn4rNqVjxDyP_459QqP1hPTBI6JyQvReHvj6wW7MgMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/invoices/create-edit.vue")
  },
  {
    name: "tenant-settings-media-types",
    path: "/:tenant()/settings/media-types",
    meta: { ...(media_45typesRKj5hWzF7EnpORWFfVcHYdQotVkR82wvaMWL5akVAYwMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/media-types.vue")
  },
  {
    name: "tenant-city-statistics",
    path: "/:tenant()/city/statistics",
    meta: { ...(index0JODX171bp_45beXj0_45lCZozxZMfCkgLqtiERZ2nDDB_45EMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/statistics/index.vue")
  },
  {
    name: "tenant-company-balance",
    path: "/:tenant()/company-balance",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/company-balance/index.vue")
  },
  {
    name: "tenant-equipments-to-qualify",
    path: "/:tenant()/equipments/to-qualify",
    meta: { ...(to_45qualifyu7UZmD_VbLVxaGN_l5QzZ_dYwLjlMg27KcZPCT6YsbIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/equipments/to-qualify.vue")
  },
  {
    name: "tenant-placer-planning",
    path: "/:tenant()/placer-planning",
    meta: { ...(indexCEqBLl6PGqf897HXmf1GlpB23_45d4IwwOX6b6BZ1h70sMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/placer-planning/index.vue")
  },
  {
    name: "tenant-report-template",
    path: "/:tenant()/report-template",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/report-template/index.vue")
  },
  {
    name: "tenant-settings-activity-log",
    path: "/:tenant()/settings/activity-log",
    meta: { ...(activity_45log3MCDHV4lqDBRL10KDwrYwC6OWPdnWUw5RK_45wtO_sFnoMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/activity-log.vue")
  },
  {
    name: "tenant-settings-email-health",
    path: "/:tenant()/settings/email-health",
    meta: { ...(email_45healthGsv_5k1E50F490eZOpQ5OFHoLT1rvVPAEqiYbPl8SNIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/email-health.vue")
  },
  {
    name: "reset-password-token-email",
    path: "/reset-password/:token()/:email()",
    meta: {"layout":"guest","middleware":["nuxt-permissions","sanctum:guest"]},
    component: () => import("/app/pages/reset-password/[token]/[email].vue")
  },
  {
    name: "tenant-audit-passengers",
    path: "/:tenant()/audit-passengers",
    meta: { ...(indexDOgdlPTfMO6EUMvU5rKU7V8dCb8AfYmrHiSmy7obqm0Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/audit-passengers/index.vue")
  },
  {
    name: "tenant-billing-entities",
    path: "/:tenant()/billing-entities",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/billing-entities/index.vue")
  },
  {
    name: "tenant-city-settings-security",
    path: "/:tenant()/city/settings/security",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"},
    component: () => import("/app/pages/[tenant]/city/settings/security.vue")
  },
  {
    name: "tenant-products-manage-prices",
    path: "/:tenant()/products/manage-prices",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/products/manage-prices.vue")
  },
  {
    name: "tenant-cashregisters-show-id",
    path: "/:tenant()/cashregisters/show/:id()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/cashregisters/show/[id].vue")
  },
  {
    name: "tenant-city-invoices-show-id",
    path: "/:tenant()/city/invoices/show/:id()",
    meta: { ...(_91id_93SgiBOiBIoqjYzU50UDLiQbEqTvJwcPxUlV62xSbUBDIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/invoices/show/[id].vue")
  },
  {
    name: "tenant-document-required",
    path: "/:tenant()/document-required",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/document-required/index.vue")
  },
  {
    name: "tenant-exportaccountancy",
    path: "/:tenant()/exportaccountancy",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/exportaccountancy/index.vue")
  },
  {
    name: "tenant-invoices-offer-invoices",
    path: "/:tenant()/invoices/offer-invoices",
    meta: { ...(offer_45invoices5HEY7JiXivm2cLiWq29f1YKX2HwHGDpb9rh2PjKPeswMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/invoices/offer-invoices.vue")
  },
  {
    name: "tenant-payment-anomalies",
    path: "/:tenant()/payment-anomalies",
    meta: { ...(indexwMU0lfOIvHEtElmFcLthDEm1tquiNdtahKK7U0wiwGQMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/payment-anomalies/index.vue")
  },
  {
    name: "tenant-reporting-payment-rates",
    path: "/:tenant()/reporting/payment-rates",
    meta: { ...(payment_45rateskXgNftDZH_Q1AklDWxymMXXKnhvLE2lWqAiXBikZ_XwMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/reporting/payment-rates.vue")
  },
  {
    name: "tenant-subscriptions-show-id",
    path: "/:tenant()/subscriptions/show/:id()",
    meta: { ...(_91id_93tzPiRv3Zxq6pFMU_GVk4_MD_eqWBJGt5_45iKdQ6cysHkMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/show/[id].vue")
  },
  {
    name: "tenant-city-market-report",
    path: "/:tenant()/city/market-report",
    meta: { ...(indexWGFqyqen_45q_45zN9xUgDD0SP8vqDXjVCy7hTMBJUFXFucMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/market-report/index.vue")
  },
  {
    name: "tenant-city-settings-appearance",
    path: "/:tenant()/city/settings/appearance",
    meta: { ...(appearanceF_454keGASRkB34lHceM6lkB_gT9qR_Is42Zq58yagtQ4Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/settings/appearance.vue")
  },
  {
    name: "tenant-invoices-credit-invoices",
    path: "/:tenant()/invoices/credit-invoices",
    meta: { ...(credit_45invoicesucZoLmr05z5TPUQAzS_45T06gWXukhxMwVRKgNyD0EjZQMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/invoices/credit-invoices.vue")
  },
  {
    name: "tenant-markets-draw-shape",
    path: "/:tenant()/markets/draw-shape",
    meta: { ...(indexJmQ_jBRbY9oMq9FLSim6MdauiDuR12EZXk5IjE4g9NUMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/markets/draw-shape/index.vue")
  },
  {
    name: "tenant-settings-equipment-types",
    path: "/:tenant()/settings/equipment-types",
    meta: { ...(equipment_45typesR4KwB9CmKMLyvbTwpDvVIvD6S8aXzK9hK1iqQfHZuLkMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/equipment-types.vue")
  },
  {
    name: "tenant-settings-placer-presence",
    path: "/:tenant()/settings/placer-presence",
    meta: { ...(placer_45presence2YgTF14F9OJ2Ey_45_IQNanSFmN35u2PkpI1P8lZQ5CFIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/placer-presence.vue")
  },
  {
    name: "tenant-settings-city-assignments",
    path: "/:tenant()/settings/city-assignments",
    meta: { ...(city_45assignmentsNaCdOz_45MNJTYlHnEXHEGy8xuZ9vO89quODBO1pmuqWIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/city-assignments.vue")
  },
  {
    name: "tenant-settings-company-balances",
    path: "/:tenant()/settings/company-balances",
    meta: { ...(company_45balancesZ5vm0hEbBsBzBec5t6Hn6CIqlVw7OKaarc2Ukry1s9gMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/company-balances.vue")
  },
  {
    name: "tenant-settings-emergency-bypass",
    path: "/:tenant()/settings/emergency-bypass",
    meta: { ...(emergency_45bypassIz_ivyRVUMDO9FeIz90GUdZ3dpdlLMLFrj76TAC9mccMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/emergency-bypass.vue")
  },
  {
    name: "tenant-subscriptions-create-edit",
    path: "/:tenant()/subscriptions/create-edit",
    meta: { ...(create_45editF96DNhSwd3pSZ3vgj4nfKp_45g8Sd_z7_45TI_45iIaqMLV6IMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/create-edit.vue")
  },
  {
    name: "tenant-invoices-noactive-invoices",
    path: "/:tenant()/invoices/noactive-invoices",
    meta: { ...(noactive_45invoicesuWY0O8EIKm6EQJwV4hbBySRgkTatfO1gV3XOcyfSGv8Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/invoices/noactive-invoices.vue")
  },
  {
    name: "tenant-placer-entry-quality",
    path: "/:tenant()/placer-entry-quality",
    meta: { ...(indexy9U_45bFfqhGVvBl75EFlt53iqMP3dYvzn8xmfeQCHnAcMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/placer-entry-quality/index.vue")
  },
  {
    name: "tenant-report-template-list",
    path: "/:tenant()/report-template/list",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/report-template/list/index.vue")
  },
  {
    name: "tenant-audit-passengers-backoffice",
    path: "/:tenant()/audit-passengers/backoffice",
    meta: { ...(backofficeYSVcXshvWtlTgdSlWKZMICkOlSlveskz4_45I_45aW57pu8Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/audit-passengers/backoffice.vue")
  },
  {
    name: "tenant-settings-agenda-entry-types",
    path: "/:tenant()/settings/agenda-entry-types",
    meta: { ...(agenda_45entry_45typeskbE4hJ4zFvEtxVasWKcmEpDzTl_453WUDOaj3Lbc6XcA4Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/agenda-entry-types.vue")
  },
  {
    name: "tenant-settings-integrations",
    path: "/:tenant()/settings/integrations",
    meta: { ...(indexUIInWBDMo7tKGchJUV0An9VpOpwOA5N31ii65AQ5YP0Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/integrations/index.vue")
  },
  {
    name: "tenant-merchants-deduplicate-search",
    path: "/:tenant()/merchants/deduplicate-search",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/merchants/deduplicate-search.vue")
  },
  {
    name: "tenant-report-template-create",
    path: "/:tenant()/report-template/create",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/report-template/create/index.vue")
  },
  {
    name: "tenant-city-settings-city-assignments",
    path: "/:tenant()/city/settings/city-assignments",
    meta: { ...(city_45assignmentsEO2YzwnN0TUviIM6sb_45q7AHQXN0znb6E9rSKtHLzB0sMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/settings/city-assignments.vue")
  },
  {
    name: "tenant-deduplications-companies",
    path: "/:tenant()/deduplications/companies",
    meta: { ...(index4wqha9bqxAki1JsinWXg8d_FEYsTpYqrcpkOds4g9wkMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/deduplications/companies/index.vue")
  },
  {
    name: "tenant-settings-integrations-organilog",
    path: "/:tenant()/settings/integrations/organilog",
    meta: { ...(organilogynBKA6dDajE7VIj944ojBekCGFb5SFjaLmeXPFTxcaAMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/integrations/organilog.vue")
  },
  {
    name: "tenant-deduplications-companies-history",
    path: "/:tenant()/deduplications/companies/history",
    meta: { ...(history2fDIjbmd9JaYkFCm5ZNV6mk0NGdmzWLGNkcLS2hvwYYMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/deduplications/companies/history.vue")
  },
  {
    name: "tenant-market-report-market_report_id",
    path: "/:tenant()/market-report/:market_report_id()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/market-report/[market_report_id].vue")
  },
  {
    name: "tenant-market-report-create-market_id",
    path: "/:tenant()/market-report/create/:market_id()",
    meta: { ...(_91market_id_931Aarbrv_45zZjldeH5aVdhykYYxMMhAHHVOZHTVQolHosMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/market-report/create/[market_id].vue")
  },
  {
    name: "tenant-settings-notification-recipients",
    path: "/:tenant()/settings/notification-recipients",
    meta: { ...(notification_45recipientsOF_E7l7CMvQ7m7yvBoLlJq0X0Wlh_45nNAd4QCpsPPEH4Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/settings/notification-recipients.vue")
  },
  {
    name: "tenant-report-template-edit-template_id",
    path: "/:tenant()/report-template/edit/:template_id()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/report-template/edit/[template_id].vue")
  },
  {
    name: "tenant-audit-passengers-report-sessionId",
    path: "/:tenant()/audit-passengers/report-:sessionId()",
    meta: { ...(report_45_91sessionId_93ndy72G2MFC65AIfeTygkSRYTV68GyvIziCZ1H8Jl_FgMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/audit-passengers/report-[sessionId].vue")
  },
  {
    name: "tenant-deduplications-deduplications_history",
    path: "/:tenant()/deduplications/deduplications_history",
    meta: { ...(deduplications_history_uwuOfsH3161qf_WOnOlfF_45r_LtAa94r_45e_45jYWnDdSQMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/deduplications/deduplications_history.vue")
  },
  {
    name: "tenant-passenger-merchants-performance",
    path: "/:tenant()/passenger-merchants-performance",
    meta: { ...(indexSJJNmSnKHx3ZoGSa1k1qzQH_eFV0XA1Dq_9gHSG_45augMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/passenger-merchants-performance/index.vue")
  },
  {
    name: "tenant-subscriptions-renewal_exceptions-id",
    path: "/:tenant()/subscriptions/renewal_exceptions/:id()",
    meta: { ...(_91id_933PWOwZ4rGaIAvEfFZdbnRp0Jns8ND088Lj71QhZutyYMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/renewal_exceptions/[id].vue")
  },
  {
    name: "tenant-market-report-daily-market_id-date",
    path: "/:tenant()/market-report/daily/:market_id()/:date()",
    meta: {"middleware":["nuxt-permissions","sanctum:auth"]},
    component: () => import("/app/pages/[tenant]/market-report/daily/[market_id]/[date].vue")
  },
  {
    name: "tenant-subscriptions-renewal_exceptions",
    path: "/:tenant()/subscriptions/renewal_exceptions",
    meta: { ...(indexBjx6Qs8GfgLgaGSDvinC_45sWik7iXARSsFu_30dGgoVcMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/renewal_exceptions/index.vue")
  },
  {
    name: "tenant-subscriptions-renewal_exceptions-create",
    path: "/:tenant()/subscriptions/renewal_exceptions/create",
    meta: { ...(createYKPkyersFQMSTjxhew7fBcnhBujmieVu73v50TNfnJEMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/renewal_exceptions/create.vue")
  },
  {
    name: "tenant-city-market-report-daily-market_id-date",
    path: "/:tenant()/city/market-report/daily/:market_id()/:date()",
    meta: { ...(_91date_93aw5yRCa8M1zWM9V3kmdkwJXPNrz2qMoqIcorWjLW3U0Meta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"],"layout":"city"} },
    component: () => import("/app/pages/[tenant]/city/market-report/daily/[market_id]/[date].vue")
  },
  {
    name: "tenant-subscriptions-renewal_exceptions-exceptions",
    path: "/:tenant()/subscriptions/renewal_exceptions/exceptions",
    meta: { ...(exceptionsNBTU73OmyCOJMBirbcSeO8_cLZxXIup3mrm3beSl8uIMeta || {}), ...{"middleware":["nuxt-permissions","sanctum:auth"]} },
    component: () => import("/app/pages/[tenant]/subscriptions/renewal_exceptions/exceptions.vue")
  },
  {
    name: "invoiceEdit",
    path: "/invoices/edit",
    meta: { ...(create_45editdu73qv_452gv4nSpZbdjsyl_7N2dt00qTcJSS9xBZW9CwMeta || {}), ...{"middleware":["sanctum:auth","nuxt-permissions"]} },
    component: () => import("~/pages/[tenant]/subscriptions/create-edit.vue")
  },
  {
    name: "invoiceCreate",
    path: "/invoices/create",
    meta: {"middleware":["sanctum:auth","nuxt-permissions"]},
    component: () => import("~/pages/[tenant]/subscriptions/create-edit.vue")
  }
]